export const kentucky = {
  "21000": "Kentucky",
  "21001": "Adair County",
  "21003": "Allen County",
  "21005": "Anderson County",
  "21007": "Ballard County",
  "21009": "Barren County",
  "21011": "Bath County",
  "21013": "Bell County",
  "21015": "Boone County",
  "21017": "Bourbon County",
  "21019": "Boyd County",
  "21021": "Boyle County",
  "21023": "Bracken County",
  "21025": "Breathitt County",
  "21027": "Breckinridge County",
  "21029": "Bullitt County",
  "21031": "Butler County",
  "21033": "Caldwell County",
  "21035": "Calloway County",
  "21037": "Campbell County",
  "21039": "Carlisle County",
  "21041": "Carroll County",
  "21043": "Carter County",
  "21045": "Casey County",
  "21047": "Christian County",
  "21049": "Clark County",
  "21051": "Clay County",
  "21053": "Clinton County",
  "21055": "Crittenden County",
  "21057": "Cumberland County",
  "21059": "Daviess County",
  "21061": "Edmonson County",
  "21063": "Elliott County",
  "21065": "Estill County",
  "21067": "Fayette County",
  "21069": "Fleming County",
  "21071": "Floyd County",
  "21073": "Franklin County",
  "21075": "Fulton County",
  "21077": "Gallatin County",
  "21079": "Garrard County",
  "21081": "Grant County",
  "21083": "Graves County",
  "21085": "Grayson County",
  "21087": "Green County",
  "21089": "Greenup County",
  "21091": "Hancock County",
  "21093": "Hardin County",
  "21095": "Harlan County",
  "21097": "Harrison County",
  "21099": "Hart County",
  "21101": "Henderson County",
  "21103": "Henry County",
  "21105": "Hickman County",
  "21107": "Hopkins County",
  "21109": "Jackson County",
  "21111": "Jefferson County",
  "21113": "Jessamine County",
  "21115": "Johnson County",
  "21117": "Kenton County",
  "21119": "Knott County",
  "21121": "Knox County",
  "21123": "Larue County",
  "21125": "Laurel County",
  "21127": "Lawrence County",
  "21129": "Lee County",
  "21131": "Leslie County",
  "21133": "Letcher County",
  "21135": "Lewis County",
  "21137": "Lincoln County",
  "21139": "Livingston County",
  "21141": "Logan County",
  "21143": "Lyon County",
  "21145": "McCracken County",
  "21147": "McCreary County",
  "21149": "McLean County",
  "21151": "Madison County",
  "21153": "Magoffin County",
  "21155": "Marion County",
  "21157": "Marshall County",
  "21159": "Martin County",
  "21161": "Mason County",
  "21163": "Meade County",
  "21165": "Menifee County",
  "21167": "Mercer County",
  "21169": "Metcalfe County",
  "21171": "Monroe County",
  "21173": "Montgomery County",
  "21175": "Morgan County",
  "21177": "Muhlenberg County",
  "21179": "Nelson County",
  "21181": "Nicholas County",
  "21183": "Ohio County",
  "21185": "Oldham County",
  "21187": "Owen County",
  "21189": "Owsley County",
  "21191": "Pendleton County",
  "21193": "Perry County",
  "21195": "Pike County",
  "21197": "Powell County",
  "21199": "Pulaski County",
  "21201": "Robertson County",
  "21203": "Rockcastle County",
  "21205": "Rowan County",
  "21207": "Russell County",
  "21209": "Scott County",
  "21211": "Shelby County",
  "21213": "Simpson County",
  "21215": "Spencer County",
  "21217": "Taylor County",
  "21219": "Todd County",
  "21221": "Trigg County",
  "21223": "Trimble County",
  "21225": "Union County",
  "21227": "Warren County",
  "21229": "Washington County",
  "21231": "Wayne County",
  "21233": "Webster County",
  "21235": "Whitley County",
  "21237": "Wolfe County",
  "21239": "Woodford County",
};
